// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

let spImgList1 = [
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-b1.png?v=1719825534",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-b2.png?v=1719825533",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-b3.png?v=1719825534",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-b4.png?v=1719825533",
];
let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p1-gray.png?v=1719825533",
   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p1-black.png?v=1719825533",
   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p1-white.png?v=1719825533",
   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p1-red.png?v=1719825533",
   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p1-blue.png?v=1719825533",

   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p3-gray.png?v=1719825533",
   "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p3-black.png?v=1719825533",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p3-white.png?v=1719825533",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p3-red.png?v=1719825533",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/20240701-p3-blue.png?v=1719825532",
  
 
  
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/5_e51282fb-eb2d-4b8a-9111-8c2a9643c7c6.png?v=1721704447",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/5_92730d15-3aa2-47b4-ad3f-39958708a62f.png?v=1721704447",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/5_9729ab10-8d59-440e-bbb8-0972d01460f3.png?v=1721704447",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/5_a54665c2-3bc0-4fc6-aba8-41f220070c12.png?v=1721704447",
  "https://cdn.shopifycdn.net/s/files/1/0583/6934/3522/files/5_b0c89938-72f3-47a1-b53b-b681b1a7f864.png?v=1721704447",
 
];
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);
    setTimeout(function(){
      let cCWidth = $(window).width();
      if(cCWidth < 749){
        console.log("////",scale)
        $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",Math.floor(scale *　10));
      }else{
        $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",scale *　1);
      }
    },300)
    

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          let cWidth = $(window).width();
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
            if(cWidth < 749){
              $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",Math.floor(scale *　10));
            }else{
              $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",scale *　1);
            }
            
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(spImgList1);

    // 找到所有跳转套餐的锚点链接
    // var links = document.querySelectorAll('a[href^="#shopping"]');
    // links.forEach(function (link) {
    //   link.addEventListener("click", function (event) {
    //     event.preventDefault(); // 阻止默认的跳转行为
    //     // var targetElement = document.getElementById('shopping');
    //     // if (targetElement) {
    //     //     targetElement.scrollIntoView({ behavior: 'smooth' });
    //     // } // 方式一
    //     const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    //     const offsetTop = targetElement.offsetTop
    //     window.scroll({
    //       top:
    //         offsetTop * $("div#root").css("zoom") -
    //         285 * $("div#root").css("zoom"),
    //       behavior: "smooth", // 使用 smooth 实现平滑滚动
    //     });

    //     // 方式二
    //   });
    // });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

function calcTotal(price, num) {
  let result = Number(price) * Number(num);
  return result.toFixed(2);
}

new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },

  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
});



// 购物车加购动效
$(".cart-btn").click(function () {
  $(this).children("img").addClass("on");
  $(".sp-header-top .sp-cart .num").show();
  setTimeout(function () {
    $(".cart-btn").children("img").removeClass("on");
  }, 500);
  $(".sp-header-top .sp-cart").addClass("on");
  setTimeout(function () {
    $(".sp-header-top .sp-cart").removeClass("on");
  }, 500);
});
let colorList = ["Gris", "Negro", "Blanco", "Rojo", "Azul"];
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let sp_img = $(".product-part .p-img")[0];
  let colorOptions = $("#sp-color .option.active").index();
  let numOptions = $("#sp-num .option.active").index();

  let _index = colorOptions + numOptions * 5;
  sp_img.src = spImgList[_index];

  $("#spColor").html(colorList[colorOptions]);
  if (colorOptions == 2) {
    $(".sp-colot-text").addClass("sp-black");
  } else {
    $(".sp-colot-text").removeClass("sp-black");
  }
});


